import { propertyQueryKeys as e } from "../usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
import { ImageProcessingStatus as r } from "@maat/api-main/types";
//#region src/properties/gallery/useRoomTypeGalleryQuery.ts
var i = 3e3, a = (a, o) => t({
	queryKey: e.unitGallery(a ?? "", o ?? ""),
	queryFn: () => n.getUnitGalleryImages(a, o),
	enabled: !!a && !!o,
	refetchInterval: (e) => (e.state.data?.images ?? []).some((e) => e.processing_status === r.Pending) ? i : !1
});
//#endregion
export { a as useRoomTypeGalleryQuery };
